import React from "react";

export default function TopTeamsPopup({
  showTopTeams,
  scrollRef,
  rowWidth,
  sortedTeams,
  doubledTopTeams,
  teamInfo,
}) {
  if (!showTopTeams) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        bottom: "7vh",
        width: "100vw",
        height: "73vh",
        zIndex: 10010,
        overflow: "hidden",
        pointerEvents: "none",
        background: "none",
      }}
    >
      <div
        className="scroll-row"
        ref={scrollRef}
        style={{
          left: 0,
          top: 0,
          height: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          gap: "2vw",
          animation: rowWidth
            ? `marquee-scroll ${Math.max(
                8,
                sortedTeams.length * 2.6
              )}s linear infinite`
            : "none",
          "--marquee-width": rowWidth ? `${rowWidth}px` : "0px",
          pointerEvents: "auto",
        }}
      >
        {doubledTopTeams.map((team, idx) => {
          const teamName = team.team;
          const selfieUrl = teamInfo[teamName];
          const score = team.points;
          const rank = sortedTeams.length - 1 - (idx % sortedTeams.length);
          return (
            <div
              key={teamName + "-" + idx}
              style={{
                height: "670px",
                width: "365px",
                minWidth: "365px",
                maxWidth: "380px",
                borderRadius: "3em",
                background: "rgba(0,0,0,0.25)",
                boxShadow:
                  rank === 0
                    ? "0 0 32px 8px #ffd700, 0 0 0 7px #fff8"
                    : rank === 1
                    ? "0 0 32px 8px #c0c0c0, 0 0 0 7px #fff8"
                    : rank === 2
                    ? "0 0 32px 8px #cd7f32, 0 0 0 7px #fff8"
                    : "0 12px 64px #000b, 0 0 0 7px #fff4",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                position: "relative",
                overflow: "visible",
                marginBottom: 2,
                border:
                  rank === 0
                    ? "7px solid #ffd700"
                    : rank === 1
                    ? "7px solid #c0c0c0"
                    : rank === 2
                    ? "7px solid #b87333"
                    : "4px solid #fff2",
              }}
            >
              {/* Medallion badge for top 3 */}
              {rank <= 2 && (
                <div
                  style={{
                    position: "absolute",
                    top: -105,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    background:
                      rank === 0
                        ? "radial-gradient(circle, #ffe066 68%, #ffd700 100%)"
                        : rank === 1
                        ? "radial-gradient(circle, #c0c0c0 68%, #f7f7f7 100%)"
                        : "radial-gradient(circle, #cd7f32 68%, #f7e1d3 100%)",
                    border:
                      rank === 0
                        ? "6px solid #ffd700"
                        : rank === 1
                        ? "6px solid #c0c0c0"
                        : "6px solid #b87333",
                    boxShadow:
                      rank === 0
                        ? "0 2px 24px #ffd700aa"
                        : rank === 1
                        ? "0 2px 24px #c0c0c088"
                        : "0 2px 24px #b8733388",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 900,
                    fontSize: 64,
                    color: "#2d2207",
                    overflow: "visible",
                  }}
                >
                  <span style={{ fontSize: "3.6rem" }}>
                    {rank === 0 ? "🥇" : rank === 1 ? "🥈" : "🥉"}
                  </span>
                </div>
              )}

              {/* Selfie */}
              <div
                style={{
                  width: "100%",
                  height: "67%",
                  borderRadius: "3em 3em 1.4em 1.4em",
                  overflow: "hidden",
                  background: "#333d",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {selfieUrl ? (
                  <img
                    src={selfieUrl}
                    alt={teamName + " selfie"}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "3em 3em 1.4em 1.4em",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff7",
                      fontSize: "11rem",
                      background: "#222c",
                    }}
                  >
                    👥
                  </div>
                )}
              </div>
              {/* Team Name */}
              <div
                style={{
                  display: "-webkit-box",
                  width: "92%",
                  fontWeight: 800,
                  color: "#fff",
                  textShadow: "0 5px 22px #000c",
                  letterSpacing: 2,
                  fontSize: "clamp(1.2rem, 2.4vw, 3.4rem)",
                  lineHeight: 1.13,
                  maxHeight: "2.5em",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textAlign: "center",
                  marginTop: 18,
                  marginBottom: 0,
                }}
              >
                {teamName}
              </div>
              {/* Points */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "auto",
                  marginBottom: 36,
                }}
              >
                <div
                  style={{
                    minWidth: 170,
                    minHeight: 80,
                    background:
                      rank === 0
                        ? "linear-gradient(90deg, #fffbe2 8%, #ffe066 85%)"
                        : rank === 1
                        ? "linear-gradient(90deg, #f2f2f2 70%, #aaa 100%)"
                        : rank === 2
                        ? "linear-gradient(90deg, #efc09a 70%, #b87333 100%)"
                        : "linear-gradient(90deg, #36394c 40%, #23232a 100%)",
                    border: "7px solid #ffe066",
                    borderRadius: "2.7em",
                    boxShadow:
                      rank === 0
                        ? "0 6px 18px #ffd700cc"
                        : rank === 1
                        ? "0 4px 10px #c0c0c0cc"
                        : rank === 2
                        ? "0 4px 10px #b87333cc"
                        : "0 1px 6px #2228",
                    color:
                      rank === 0
                        ? "#ad8d00"
                        : rank === 1
                        ? "#909090"
                        : rank === 2
                        ? "#834500"
                        : "#ffe066",
                    fontWeight: 900,
                    fontSize: "3.1rem",
                    textAlign: "center",
                    alignSelf: "center",
                    padding: "0.3em 0.7em",
                  }}
                >
                  {score > 0 ? `+${score}` : score}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <style>
        {`
          @keyframes marquee-scroll-right {
            0%   { transform: translateX(calc(-1 * var(--marquee-width))); }
            100% { transform: translateX(0); }
          }
          .scroll-row {
            will-change: transform;
          }
        `}
      </style>
    </div>
  );
}
